export default __webpack_public_path__ + "static/media/agustin3.0c850e3a.png";